import { render, staticRenderFns } from "./PersonalCenterPage.vue?vue&type=template&id=601d266f&scoped=true"
import script from "./PersonalCenterPage.vue?vue&type=script&lang=js"
export * from "./PersonalCenterPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalCenterPage.vue?vue&type=style&index=0&id=601d266f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601d266f",
  null
  
)

export default component.exports